export default __webpack_public_path__ + "static/media/p3-9.de95b2d5.png";